import PropTypes from 'prop-types'; // Optional, but good practice
import classNames from 'classnames'

const defaultButtonStylesArray = "text-xs text-rr-button-white-primary rounded px-2 py-1 ml-1 mr-1 shadow-sm ring-1 ring-inset ring-gray-300".split(/\s+/);

const buttonClassNames = (isSelected: boolean) => classNames(
  defaultButtonStylesArray,
  {
    'background-button-gray' : isSelected,
    'background-button-white': !isSelected
  }
);

/**
 * A reusable component displaying a group of buttons,
 * highlighting the currently selected one with a checkmark.
 * State is managed by the parent component.
 */
function ButtonGroup({ options, selectedOption, onSelect }) {
  return (
    <div role="group">
      {options.map((option) => {
        const isSelected = option === selectedOption;
        return (
          <button
            key={option} // Use the option string as the key (assuming they are unique)
            type="button" // Good practice for non-submitting buttons
            className={buttonClassNames(isSelected)}
            onClick={() => onSelect(option)} // Call the parent's handler with the clicked option
            aria-pressed={isSelected} // Accessibility: indicates toggle state
          >
            {isSelected && <span>✓ </span>}
            {option}
          </button>
        );
      })}
    </div>
  );
}

// PropTypes for defining expected props and their types
ButtonGroup.propTypes = {
  /** Array of strings representing the button labels/values */
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  /** The currently selected option value (must be one of the strings in `options`) */
  selectedOption: PropTypes.string.isRequired,
  /** Function to call when a button is clicked. Receives the clicked option value as an argument. */
  onSelect: PropTypes.func.isRequired,
};

export default ButtonGroup;
